import React from 'react';
export function forward(ref, forwardRef) {
    if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    }
}
export function forwardValue(ref, value) {
    if (ref) {
        if (typeof ref === "function") {
            ref(value);
        }
        else {
            ref.current = value;
        }
    }
}
export function useForward(ref, value) {
    var forwardRef = React.useRef(value || null);
    React.useEffect(function () {
        if (value)
            forwardValue(ref, value);
        else
            forward(ref, forwardRef);
    }, [ref, forwardRef.current, value]);
    return forwardRef;
}
